<template>
  <div>
    <div>
      <el-select style="width: 100%" v-model="isFinish" clearable placeholder="请选择业务单状态">
        <el-option :value="1" label="完成"></el-option>
        <el-option :value="0" label="未完成"></el-option>
      </el-select>
    </div>

    <div class="btn">
      <el-button @click="save()" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import {saleorder} from "@/api/saleorder";
import {msg} from "@/assets/js/my-vue-element-ui-js";

export default {
  name: 'SaleOrderEventOrderStatusUpdate',
  props: {
    id: Number
  },

  data() {
    return {
      isFinish: 0,
    };
  },

  methods: {
    save() {
      saleorder.updateEventOrderStatus(this.id, this.isFinish).then(res => {
        msg(res, this);
        if (res.code === 200) {
          this.$emit('updated');
        }
      })
    },
  },


};
</script>

<style scoped>
.btn {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
</style>
